"use strict";

var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("div", {
    className: this.props.getClassName('color-picker-reset-color')
  }, /*#__PURE__*/React.createElement("div", {
    className: "color-picker-reset-color-option color-picker-reset-color-button",
    onClick: this.resetColor,
    style: {
      backgroundColor: this.initialColor
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "color-picker-reset-color-option",
    style: {
      backgroundColor: this.props.value
    }
  }));
};